import { render, staticRenderFns } from "./GamesBetslipInput.vue?vue&type=template&id=62d167d7&scoped=true"
import script from "./GamesBetslipInput.vue?vue&type=script&lang=js"
export * from "./GamesBetslipInput.vue?vue&type=script&lang=js"
import style0 from "./GamesBetslipInput.vue?vue&type=style&index=0&id=62d167d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62d167d7",
  null
  
)

export default component.exports